import { CustomSelect as Select } from './Select';

export type * from './types';

export default Select;
